import { Component } from '@verndale/core';
import Chart from 'chart.js';

import { colors } from './stats-graph';
import { insertAfter } from '../utils/dom';

class DataViz extends Component {
  setupDefaults() {
    this.dom = {
      $wrapper: this.el._$('.data-viz__wrapper'),
      $list: this.el._$('.data-viz__points-list'),
      $canvas: this.el._$('.data-viz__canvas'),
      $canvasContext: this.el._$('.data-viz__canvas').getContext('2d'),
      $points: this.el._$$('.data-viz__point'),
      $bulletWithoutColor: this.el._$$('.data-viz__bullet[data-color]')
    };

    this.colors = this.el.dataset.colors;
    this.values = this.el.dataset.values;
    this.type = this.el.dataset.type;

    this.setPointsColor();
    this.moveDOM();

    this.observer = new window.IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.chart) {
            setTimeout(::this.initGraph, 500);
          }
        });
      },
      {
        threshold: 0.6
      }
    );
    this.observer.observe(this.dom.$canvas);
  }

  setPointsColor() {
    const { $bulletWithoutColor } = this.dom;

    if ($bulletWithoutColor) {
      $bulletWithoutColor.forEach((point) => {
        const [key, variation] = point.dataset.color.split('.');
        point.style.backgroundColor = colors[key][variation];
      });
    }
  }

  moveDOM() {
    const { $wrapper, $list } = this.dom;

    insertAfter($list, $wrapper);
  }

  initGraph() {
    const { $canvasContext } = this.dom;

    this.chart = new Chart($canvasContext, {
      type: this.type,
      data: {
        datasets: [
          {
            data: this.values.split(',').map(Number),
            backgroundColor: this.colors.split(',').map((color) => {
              const colorCode = color.trim();

              if (color.includes('.')) {
                const [key, variation] = colorCode.split('.');

                if (key in colors) {
                  return colors[key][variation];
                }
              }

              return colorCode;
            })
          }
        ]
      },
      options: {
        animation: {
          duration: 2000
        },
        responsive: true,
        maintainAspectRatio: true,
        scaleLabel: {
          display: false
        },
        hover: {
          mode: null
        },
        aspectRatio: 1,
        legend: {
          display: false
        },
        tooltips: {
          enabled: false
        },
        yAxes: [
          {
            type: 'linear',
            position: 'left'
          }
        ]
      }
    });
  }
}

export default DataViz;
